export const useScrollTrigger = function (createTween, manual = false) {
  const { app, debug, browser } = useStores()

  const tween = ref(null)

  const _init = function () {
    if (tween.value) _destroy()
    tween.value = createTween()
  }

  const _destroy = function () {
    if (!tween.value) return
    tween.value?.scrollTrigger?.kill?.()
    tween.value?.kill?.()
  }
  // onUnmounted(_destroy)

  if (!manual) {
    onMounted(_init)
  }

  // watch(() => [browser.breakpoint], _init)

  return {
    tween,
    init: _init,
    destroy: _destroy,
  }
}

export default useScrollTrigger
